"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, ["src", "size"]);

  var defaultAvatar = 'https://media.versoapp.com/Images/default-avatar.svg';
  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: _extends({
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundImage: "url(" + (src ? src : defaultAvatar) + ")",
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      flex: '0 0 auto'
    }, src && {
      borderColor: 'neutral.1',
      borderWidth: 'regular',
      borderStyle: 'solid'
    })
  }));
};

Avatar.propTypes = {
  src: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)])
};
Avatar.defaultProps = {
  size: 8
};
var _default = Avatar;
exports["default"] = _default;